import { render, staticRenderFns } from "./CustomSurcharges.vue?vue&type=template&id=425e7843&scoped=true"
import script from "./CustomSurcharges.vue?vue&type=script&lang=js"
export * from "./CustomSurcharges.vue?vue&type=script&lang=js"
import style0 from "./CustomSurcharges.vue?vue&type=style&index=0&id=425e7843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e7843",
  null
  
)

export default component.exports